<script lang="ts">
    import Footer from '$lib/components/_page/Footer.svelte';
    import {afterNavigate} from '$app/navigation';
    import {getContext, type Snippet} from 'svelte';
    import {keyDevice} from '$lib/context-keys';
    import {DeviceType} from '$lib/classes/_enum/device-type';
    import type {Device} from '$lib/classes/state/device.svelte';

    const device: Device = getContext(keyDevice)

    interface Props {
        children: Snippet;
        footer?: boolean;
        pageMaxWidth?: number;
        yScroll?: string;
    }

    // prettier-ignore
    let {
        children,
        footer = false,
        pageMaxWidth = 1200,
        yScroll = 'auto',
    }: Props = $props()

    let pageWrapper: HTMLDivElement

    afterNavigate(() => pageWrapper.scrollTop = 0)
</script>

<div id="page-wrapper"
     data-testid="page-wrapper"
     bind:this={pageWrapper}
     class:styled-scrollbars={device.current === DeviceType.Desktop}
     style:overflow-y={yScroll}
     style="--page-max-width: {pageMaxWidth}px;"
>
    <div id="page-slot-wrapper">
        {@render children?.()}
    </div>

    {#if footer}
    <div id="footer-wrapper">
            <Footer/>
    </div>
    {/if}

</div>

<style>
    #page-wrapper {
        display: grid;
        justify-items: center;
        grid-template-rows: 1fr max-content 3fr;
        grid-template-columns: 100%;
        width: 100%;
        height: 100%;
        background: var(--bg-page);
        border-left: 2px solid var(--color-dark);

        --page-padding-inline: 6rem;
        --page-padding-block: 4rem;
    }

    #page-slot-wrapper {
        grid-row: 2;
        width: 100%;
        /*noinspection CssUnresolvedCustomProperty*/
        max-width: var(--page-max-width);
        padding-block: var(--page-padding-block);
        padding-inline: var(--page-padding-inline);
        /*border: 1px solid purple;*/
    }

    #footer-wrapper {
        margin-top: 2rem;
        align-self: flex-end;
        grid-row: 3;
        width: 100%;
        /*noinspection CssUnresolvedCustomProperty*/
        max-width: var(--page-max-width);
    }

    @media (max-width: 1000px) {
        #page-wrapper {
            --page-padding-inline: 1.5rem;
            --page-padding-block: 2rem;
            border: revert;
        }

        #page-slot-wrapper {
            border: revert;
        }
    }
</style>